module.exports = __webpack_public_path__ + "img/matches.137449c5.svg";